import axios from 'axios'
import { getUserCookie } from '../helperFunctions/cookieToken'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
})

// Paths where 401 should NOT trigger logout
const AUTH_FLOW_PATHS = ['/authenticate', '/gAuthenticate', '/blacklist']

// Incremented by endAuthSession() when the user is logged out. Every request is
// stamped with the generation it was sent under, so a 401 from a request that
// was still in flight when the session ended (concurrent 401s, or a slow
// response arriving after the user has already signed in again) is recognised
// as stale and can never log out the current session.
let sessionGeneration = 0

export const endAuthSession = () => {
  sessionGeneration += 1
}

const stampSessionGeneration = (config) => {
  config.sessionGeneration = sessionGeneration
  return config
}

const handleResponseError = (error) => {
  const url = error.config?.url ?? ''
  const isAuthFlow = AUTH_FLOW_PATHS.some((path) => url.includes(path))
  const isCurrentSession = error.config?.sessionGeneration === sessionGeneration

  // No session cookie means there is nothing to log out of (e.g. a 401 on the
  // login or set-password pages) -- redirecting there would break that flow.
  if (
    error.response?.status === 401 &&
    !isAuthFlow &&
    isCurrentSession &&
    getUserCookie()
  ) {
    window.dispatchEvent(new Event('auth:unauthorized'))
  }

  return Promise.reject(error)
}

const registerSessionInterceptors = (client) => {
  client.interceptors.request.use(stampSessionGeneration)
  client.interceptors.response.use((response) => response, handleResponseError)
}

// Registered on both the axios singleton (used by the raw-axios service files)
// and axiosInstance, since interceptors are scoped per instance.
registerSessionInterceptors(axios)
registerSessionInterceptors(axiosInstance)

export default axiosInstance
